import { render, staticRenderFns } from "./CoSyncSettingDrawer.vue?vue&type=template&id=34fd83ef&scoped=true&"
import script from "./CoSyncSettingDrawer.vue?vue&type=script&lang=ts&"
export * from "./CoSyncSettingDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./CoSyncSettingDrawer.vue?vue&type=style&index=0&id=34fd83ef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fd83ef",
  null
  
)

export default component.exports